import { useCallback } from 'react';

import { useGameConfig } from '../../config/GameConfigProvider';
import { fetchHelpAction } from '../apiActions/fetchHelpAction';
import { useAutoplayHiddenFlag } from '../compositeSelectors/useAutoplayHiddenFlag';
import { useCoreDispatch } from '../CoreStore';
import { useConfigSlice } from '../slices/config/selectors';
import { useSettingsSlice } from '../slices/settings/selectors';

const GAME_BASE_PATH = location.pathname.substring(0, location.pathname.lastIndexOf('/'));
const GAME_HELP_FILE_PATH = GAME_BASE_PATH + `/assets/translations/help`;

export const useHelpFetcherConnected = () => {
  const currentLanguage = useSettingsSlice.currentLanguage();
  const hideSubtitles = !useConfigSlice.isSubtitlesAvailable();
  const gameType = useConfigSlice.getGameType(); // Comes from the session url query param `gametype`
  const hideAutoplay = useAutoplayHiddenFlag();
  const dispatch = useCoreDispatch();

  const {
    config: { helpConfig },
  } = useGameConfig();

  const helpChapters = Object.keys(helpConfig);

  const fetchHelpFile = useCallback(() => {
    if (gameType) {
      return dispatch(
        fetchHelpAction({
          url: GAME_HELP_FILE_PATH,
          lang: currentLanguage,
          hideAutoplay,
          hideSubtitles,
          gameType,
        })
      );
    }
  }, [currentLanguage, dispatch, gameType, hideAutoplay, hideSubtitles]);

  return { fetchHelpFile, helpConfig, helpChapters };
};
